import React, { useState } from 'react';
import { Modal, Button } from '@mui/material';
import { Card, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

export default function GaleriaModal({ images, diaDoEvento, imageUrl }) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Card onClick={handleOpen} style={{ minWidth: 150, maxWidth: 500, borderRadius: '15px', flex: 1, flexGrow: 1 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="180"
                        image={imageUrl}
                        alt={`Fotos do ${diaDoEvento}`}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" color="rgba(0, 90, 156)" textAlign="center">
                            Fotos do {diaDoEvento}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
            <Modal open={open} onClose={handleClose}>
                <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: 'white', maxWidth: '90%', maxHeight: '90%', borderRadius: '8px', overflow: 'auto' }}>
                        <Button onClick={handleClose} style={{ position: 'absolute', top: '50px', right: '50px', backgroundColor: '#fff', color: 'red' }}>Fechar</Button>
                        <div style={{ padding: '20px' }}>
                            <ImageGallery
                                items={images.map(image => ({
                                    original: image.url,
                                    thumbnail: image.url 
                                }))}
                                thumbnailPosition="bottom"
                                autoPlay={true}
                                showBullets={true}
                                showPlayButton={false}
                                showThumbnails={window.innerWidth > 600}
                                lazyLoad={true}
                                useBrowserFullscreen={false}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

